<template>
  <div>
    <el-upload>
      <el-button slot="trigger" type="primary">{{ $t('SeaExport.PTImport') }}</el-button>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'PtExcelUpload'
}
</script>

<style scoped>

</style>
